import React from "react";
import Select from "react-select";
import { Props as ReactSelectProps } from "react-select";

import {
  Control,
  DropdownIndicator,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
} from "./components";
import { useStyles } from "./styles";

const standardComponents = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
  DropdownIndicator,
  IndicatorSeparator: null,
};

type IProps = ReactSelectProps;

interface Option {
  label: string;
  value: string;
}

export const RawSelectField: React.FunctionComponent<IProps> = ({
  value,
  onBlur,
  onChange,
  components,
  options,
  classes,
  isClearable = false,
  isMulti = false,
  isDisabled = false,
  margin = "dense",
  ...props
}: IProps) => {
  const customClasses = useStyles({ margin, isDisabled, isMulti });
  const mergedComponents = {
    ...standardComponents,
    ...components,
  };
  const mergedClasses = {
    ...customClasses,
    ...classes,
  };

  return (
    <Select
      classes={mergedClasses}
      options={options}
      components={mergedComponents}
      placeholder=""
      value={value}
      onBlur={onBlur}
      onChange={onChange}
      isClearable={isClearable}
      isDisabled={isDisabled}
      margin={margin}
      isMulti={isMulti}
      {...props}
    />
  );
};
